import styled from 'styled-components';
import { ApPopover, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const Header = styled.div`
	padding: 16px 32px 4px 32px;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	border-bottom: 1px solid ${colors.grey3};
`;

export const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	padding-bottom: 12px;
`;

export const InputWrapper = styled.div`
	display: flex;
	flex-direction: column;
	${({ width }) => (width ? `min-width: ${width}px` : 'width: 100%')};

	margin-right: 24px;

	> div > div {
		letter-spacing: 0.3px;
	}

	input,
	select {
		min-width: 80px;
	}

	&:last-child {
		margin-right: 0;
	}
`;

export const Label = styled.div`
	font-size: 13px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	padding-bottom: 4px;
`;

export const IconWrapper = styled.div`
	height: 16px;
	width: 16px;
	margin-top: 20px;
`;

export const FooterWrapper = styled.div`
	position: absolute;
	padding: 0 32px 16px 32px;
	bottom: 0;
`;

export const TooltipContent = styled.div`
	text-align: left;
`;

export const StyledPopover = styled(ApPopover)`
	z-index: 998 !important;
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	text-align: center;
	padding: 16px;
`;
